import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

/**
 * CIN-7070: single-select of the company's boards — the sibling of StageSelect.
 * value/onChange use the board id. The caller passes `boards` (from useTaskBoards)
 * because it already needs them to decide whether to show this field: a
 * single-board company has nothing to choose, so the modals leave it out.
 *
 * `isOptionAllowed(board)` hides boards the caller must not offer (the detail
 * modal hides boards that don't accept tasks from other boards). The current value
 * always stays in the list.
 */
export const BoardSelect = ({
  boards,
  value,
  onChange,
  label = 'Board',
  disabled,
  isOptionAllowed,
  helperText
}) => {
  const options = isOptionAllowed ? boards.filter(b => b.id === value || isOptionAllowed(b)) : boards;
  const selected = boards.find(b => b.id === value) || null;
  return <Autocomplete options={options} getOptionLabel={option => option.name || ''} isOptionEqualToValue={(option, val) => option.id === val.id} value={selected} onChange={(_e, val) => onChange(val ? val.id : null)} disabled={disabled} disableClearable renderInput={params => <TextField {...params} label={label} helperText={helperText} />} sx={{
    '& .MuiOutlinedInput-root': {
      borderRadius: '14px'
    }
  }} />;
};